import { motion } from "framer-motion";
import { MEDIA } from "../lib/media";
import { ChevronDown, MapPin } from "lucide-react";

export const HeroSection = () => {
  return (
    <section id="hero" data-testid="hero-section" className="relative h-screen w-full overflow-hidden">
      {/* Background Video */}
      <video
        data-testid="hero-video"
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        poster=""
      >
        <source src={MEDIA.heroVideo} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="hero-overlay absolute inset-0" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="overline text-[#FAF7F2]/80 mb-4"
        >
          Restaurante & Hospedaje
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          data-testid="hero-title"
          className="font-heading text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-[#FAF7F2] tracking-tighter leading-none font-light"
        >
          Suchimex
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          data-testid="hero-subtitle"
          className="mt-6 text-base md:text-lg text-[#FAF7F2]/85 font-body max-w-lg leading-relaxed"
        >
          Sabores que enamoran, descanso que se disfruta
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
          className="mt-2 overline text-[0.65rem] text-[#FAF7F2]/60"
        >
          Suchitoto, El Salvador
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-10"
        >
          <a
            href="https://drive.google.com/file/d/1mple6-Br5agmk7h8X32byPCPLAjHXIET/view"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-menu-completo"
            className="overline text-[0.7rem] bg-[#FAF7F2] text-[#2D2A26] px-8 py-3 hover:bg-[#EBE3D5] transition-all duration-300 hover:-translate-y-0.5"
          >
            Ver Menú
          </a>
          <a
            href="#reservar"
            data-testid="hero-cta-hospedaje"
            className="overline text-[0.7rem] border border-[#FAF7F2]/60 text-[#FAF7F2] px-8 py-3 hover:bg-[#FAF7F2]/10 transition-all duration-300 hover:-translate-y-0.5"
          >
            Solicitar Hospedaje
          </a>
          <a
            href="#contacto"
            data-testid="hero-cta-contacto"
            className="overline text-[0.7rem] border border-[#FAF7F2]/60 text-[#FAF7F2] px-8 py-3 hover:bg-[#FAF7F2]/10 transition-all duration-300 hover:-translate-y-0.5"
          >
            Contactar
          </a>
          <a
            href="https://www.google.com/maps/search/?api=1&query=Pasaje+El+Calvario+2-BB+Suchitoto+El+Salvador+Suchimex"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-ubicacion"
            className="overline text-[0.7rem] border border-[#FAF7F2]/60 text-[#FAF7F2] px-8 py-3 hover:bg-[#FAF7F2]/10 transition-all duration-300 hover:-translate-y-0.5 inline-flex items-center gap-2"
          >
            <MapPin size={14} />
            Ubicación
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <a href="#nosotros" data-testid="scroll-indicator" className="flex flex-col items-center gap-2">
          <span className="overline text-[0.6rem] text-[#FAF7F2]/50">Descubre más</span>
          <ChevronDown className="text-[#FAF7F2]/50 animate-bounce" size={20} />
        </a>
      </motion.div>
    </section>
  );
};
